<template>
  <section class="video">
    <div class="container">
      <div class="box_video">
        <div class="box_title">
          视频资料
        </div>
        <a-tabs v-model:activeKey="tab.active" type="card" size="small"
                :tabPosition="$Store.Public().isGridMatch('>',$Enum.GridEnum.MD)?'left':'top'"
                :tabBarGutter="0" animated>
          <a-tab-pane v-for="(item,index) in tab.data"
                      :key="index" :tab="item.title">
            <a-row :gutter="[20,20]">
              <a-col v-for="v in $Lodash.slice(item.content,(item.page-1)*getPageSize(),item.page*getPageSize())"
                     :xs="24" :md="12" :lg="8">
                <div class="box_item"
                     @click="$Store.Page().openModal('modalVideo',v.video)">
                  <div class="image">
                    <i :style="{background:`url('${v.image}')`}" />
                  </div>
                  <div class="text">
                    {{ v.title }}
                  </div>
                </div>
              </a-col>
              <a-col :span="24">
                <div class="box_pagination">
                  <a-pagination size="small" :total="item.content.length"
                                :pageSize="getPageSize()" :show-total="total=>`共 ${total} 个`"
                                @change="page=>{item.page=page;}" />
                </div>
              </a-col>
            </a-row>
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'databaseVideo',
  data(): DataInterface {
    return {
      tab: {
        active: 0,
        data: [
          {
            title: '关于星汉未来',
            page: 1,
            content: [
              {
                title: '测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频',
                image: '',
                video: 'https://gf-files-lf.oss-cn-beijing.aliyuncs.com/video/SchedulX-%E4%BA%91%E5%8E%9F%E7%94%9F%E5%9F%BA%E7%A1%80%E6%B2%BB%E7%90%86%E5%B9%B3%E5%8F%B0.mp4'
              },
              {
                title: '测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频',
                image: '',
                video: 'https://gf-files-lf.oss-cn-beijing.aliyuncs.com/video/SchedulX-%E4%BA%91%E5%8E%9F%E7%94%9F%E5%9F%BA%E7%A1%80%E6%B2%BB%E7%90%86%E5%B9%B3%E5%8F%B0.mp4'
              },
              {
                title: '测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频',
                image: '',
                video: 'https://gf-files-lf.oss-cn-beijing.aliyuncs.com/video/SchedulX-%E4%BA%91%E5%8E%9F%E7%94%9F%E5%9F%BA%E7%A1%80%E6%B2%BB%E7%90%86%E5%B9%B3%E5%8F%B0.mp4'
              },
              {
                title: '测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频',
                image: '',
                video: 'https://gf-files-lf.oss-cn-beijing.aliyuncs.com/video/SchedulX-%E4%BA%91%E5%8E%9F%E7%94%9F%E5%9F%BA%E7%A1%80%E6%B2%BB%E7%90%86%E5%B9%B3%E5%8F%B0.mp4'
              },
              {
                title: '测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频',
                image: '',
                video: 'https://gf-files-lf.oss-cn-beijing.aliyuncs.com/video/SchedulX-%E4%BA%91%E5%8E%9F%E7%94%9F%E5%9F%BA%E7%A1%80%E6%B2%BB%E7%90%86%E5%B9%B3%E5%8F%B0.mp4'
              },
              {
                title: '测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频测试视频',
                image: '',
                video: 'https://gf-files-lf.oss-cn-beijing.aliyuncs.com/video/SchedulX-%E4%BA%91%E5%8E%9F%E7%94%9F%E5%9F%BA%E7%A1%80%E6%B2%BB%E7%90%86%E5%B9%B3%E5%8F%B0.mp4'
              }
            ]
          },
          {
            title: '云原生智能运维平台',
            page: 1,
            content: [
              {
                title: 'test-1',
                image: '',
                video: ''
              }
            ]
          },
          {
            title: '阿忠伯聊云原生',
            page: 1,
            content: [
              {
                title: 'test-1',
                image: '',
                video: ''
              }
            ]
          },
          {
            title: 'Meetup技术研讨',
            page: 1,
            content: [
              {
                title: 'test-1',
                image: '',
                video: ''
              }
            ]
          }
        ]
      }
    };
  },
  methods: {
    /**
     * 获取页面尺寸
     * @return {number} 尺寸
     */
    getPageSize(): number {
      return $Store.Public().isGridMatch('>', $Enum.GridEnum.MD) ? 6 : 3;
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@imagePublic: '@{src_image}public/';
@image: '@{src_image}page/database/';
@p: 70px;
@b1: 1px solid #EDEEF5;
@b2: 1px solid @color_white;

.video {
  overflow: hidden;
  position: relative;
  z-index: 0;
  padding: 20px @padding;
  background: @color_7;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0 auto;
  }
}

.box_video {
  overflow: hidden;
  position: relative;
  background: @color_white;
  border: @b1;
  border-radius: 5px;
  
  .box_title {
    overflow: hidden;
    position: relative;
    padding: 10px @p 10px 25px;
    border-bottom: @b1;
    .font(left, 40px, @color_12, @text_big, true);
    
    &::before {
      content: '';
      display: inline-block;
      margin: 0 22px 0 0;
      .bg('@{image}decorate.png', 22px, 20px, true);
      .transform(translateY(3px));
    }
  }
}

.ant-tabs {
  &:deep(.ant-tabs-nav) {
    margin: 0;
    
    .ant-tabs-tab {
      @h: 60px;
      position: relative;
      width: 250px;
      height: @h;
      padding: 0 0 0 40px;
      .borderBox();
      background: @color_white;
      border-top: @b2;
      border-left: none;
      border-right: @b1;
      border-bottom: @b2;
      .transition(border 0s);
      
      &:first-child {
        border-top: @b2 !important;
      }
      
      &.ant-tabs-tab-active {
        border-top: @b1;
        border-left: none;
        border-right: none;
        border-bottom: @b1;
        
        &::before {
          content: '';
          display: block;
          .position(left);
          width: 4px;
          background: @color_6;
        }
        
        .ant-tabs-tab-btn {
          color: @color_6;;
        }
      }
      
      .ant-tabs-tab-btn {
        .font(left, @h, @color_black, @text);
      }
    }
    
    .ant-tabs-ink-bar {
      display: none;
    }
  }
  
  &:deep(.ant-tabs-content) {
    .ant-tabs-tabpane {
      overflow: hidden;
      position: relative;
      padding: 20px;
      min-height: 560px;
    }
  }
}

.ant-row {
  .box_item {
    overflow: hidden;
    position: relative;
    max-width: 300px;
    margin: 0 auto;
    cursor: pointer;
    
    &:hover {
      .image {
        i {
          .transform(translate(1.05, 1.05));
        }
      }
      
      .text {
        color: @color_6;
      }
    }
    
    .image {
      position: relative;
      height: 170px;
      background-color: fade(@color_black, 80);
      border-radius: 5px;
      
      &::before {
        content: '';
        display: block;
        .center();
        z-index: 1;
        .bg('@{imagePublic}video_play.png', 60px, 60px, true);
      }
      
      i {
        display: block;
        .center();
        z-index: 0;
        .transition(transform @time);
        background-position: center !important;
        background-size: cover !important;
      }
    }
    
    .text {
      position: relative;
      height: 52px;
      margin: 5px 0 0;
      .font(justify, @text+@line, @color_black, @text);
      .ellipsis(2);
      .transition(color @time);
    }
  }
  
  .box_pagination {
    text-align: right;
  }
}

@media screen and (max-width: -1px+@grid_md) {
  @p: 20px;
  
  .box_video {
    .box_title {
      padding: 10px @p;
      .font(left, 30px, @color_12, @text_big_mo, true);
      
      &::before {
        margin: 0 15px 0 0;
      }
    }
  }
  
  .ant-tabs {
    &:deep(.ant-tabs-nav) {
      .ant-tabs-tab {
        @h: 50px;
        width: auto;
        height: @h;
        padding: 0 15px;
        border-top: none !important;
        border-left: @b2;
        border-right: @b2;
        border-bottom: @b1;
        
        &:first-child {
          border-top: none !important;
          border-left: none !important;
        }
        
        &.ant-tabs-tab-active {
          border-top: none;
          border-left: @b1;
          border-right: @b1;
          border-bottom: @b2;
          
          &::before {
            .position(top);
            width: 100%;
            height: 4px;
          }
        }
        
        .ant-tabs-tab-btn {
          .font(left, @h, @color_black, @text_mo);
        }
      }
    }
  }
  
  .ant-row {
    .box_item {
      .text {
        .font(justify, @text_mo+@line_mo, @color_black, @text_mo);
      }
    }
  }
}
</style>